var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links-wrapper"},_vm._l((_vm.menu),function(item){return _c('router-link',{key:item.type,staticClass:"links-wrapper-item",attrs:{"to":`/${item.type}`}},[_vm._v("\n    "+_vm._s(_vm.$t(`ui.button.${item.text}`))+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }